import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { PublicHeader } from "../components/PublicHeader";
import { StatusPanel } from "../components/StatusPanel";
import { getReviewStatus } from "../lib/applicationService";
import { isFixtureMode } from "../lib/memberService";
import { isBackendConfigured } from "../lib/supabase";
import type { ReviewStatus } from "../lib/types";

export function ReviewPage() {
  const { token = "" } = useParams();
  const query = useQuery({
    queryKey: ["review", token],
    queryFn: () => getReviewStatus(token),
    enabled: Boolean(token && (isBackendConfigured || isFixtureMode)),
  });

  return (
    <div className="public-page">
      <PublicHeader />
      <main id="main-content" className="review-shell">
        <section className="review-card">
          <span className="eyebrow">APPLICATION STATUS</span>
          {!isBackendConfigured && !isFixtureMode ? (
            <StatusPanel title="Backend not connected" message="Add Supabase environment variables to load a real review status." />
          ) : query.isLoading ? (
            <h1>Loading your status…</h1>
          ) : query.isError || !query.data ? (
            <StatusPanel title="We could not find that application" message="Check the private link or start a new application." kind="error" />
          ) : (
            <>
              <h1>{statusTitle(query.data.status)}</h1>
              <p>{query.data.nextStep}</p>
              <div className="review-status-grid">
                <div><span>Status</span><strong>{query.data.status.replace("_", " ")}</strong></div>
                <div><span>Guardian</span><strong>{query.data.guardianRequired ? (query.data.guardianApproved ? "Approved" : "Required") : "Not needed"}</strong></div>
                <div><span>Sent</span><strong>{new Date(query.data.submittedAt).toLocaleDateString()}</strong></div>
              </div>
            </>
          )}
          <div className="hero-actions"><Link className="btn" to="/">BACK HOME</Link><Link className="btn primary" to="/login">MEMBER LOGIN</Link></div>
        </section>
      </main>
    </div>
  );
}

function statusTitle(status: ReviewStatus["status"]) {
  if (status === "invited" || status === "accepted") return "Your invite is ready.";
  if (status === "waitlisted") return "You are on the waitlist.";
  if (status === "declined" || status === "rejected") return "Not this round.";
  if (status === "guardian_pending") return "Guardian approval is needed.";
  return "Your application is under review.";
}
